
import React from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ChevronLeft } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import LoadingSpinner from "@/components/common/LoadingSpinner";
import { fetchReagentById } from "@/services/reagents/fetchReagentById";
import SwapRequestForm from "@/components/swap/SwapRequestForm";
import ReagentNotFound from "@/components/reagents/ReagentNotFound";
import { toast } from "sonner";

const SwapRequestPage: React.FC = () => {
  // Updated to use reagentId which matches the route parameter
  const { reagentId } = useParams<{ reagentId: string }>();
  const navigate = useNavigate();
  
  const { data: reagent, isLoading, error } = useQuery({
    queryKey: ['reagent', reagentId],
    queryFn: async () => {
      if (!reagentId) return null;
      const result = await fetchReagentById(reagentId);
      if (!result) {
        toast.error("Failed to load reagent details");
        return null;
      }
      return result;
    },
    enabled: !!reagentId,
  });

  if (isLoading) {
    return (
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <div className="flex-1 flex items-center justify-center">
          <LoadingSpinner size="lg" />
        </div>
        <Footer />
      </div>
    );
  }

  if (error || !reagent) {
    return <ReagentNotFound />;
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <div className="container mx-auto px-4 py-8 flex-grow">
        <div className="mb-4">
          <Link to={`/reagents/${reagentId}`} className="text-reagent-blue hover:underline inline-flex items-center">
            <ChevronLeft className="h-4 w-4 mr-1" />
            Back to Reagent
          </Link>
        </div>
        
        <div className="max-w-3xl mx-auto">
          <SwapRequestForm reagent={reagent} />
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default SwapRequestPage;
